import {apiGet} from './index'

// 获取图书馆列表
export const getLibrayMaterialBill = (params) => apiGet(`/api/libray/materialBill`, params)

// 获取图书馆Banner列表
export const getLibrayBannerApi = (params) => apiGet(`/api/johnson/banners/libraryBanner`)

// 获取金刚卫下的图片入口
export const getLibrayBannerByModuleApi = (module) => apiGet(`/api/johnson/banners?pageNum=1&pageSize=100&module=${module}`)

// 获取图书馆跳转链接
export const getMaterialBillLink = (params) => apiGet('/api/libray/materialBill/link', params)

// 获取图书馆素材详情
export const getMaterialDetailApi = (materialNo) => apiGet(`/api/libray/materialBill/detail/${materialNo}`)

export const setReadMaterialId = (fileId) => apiGet(`/api/libray/materialBill/read/${fileId}`)



// WEBPACK FOOTER //
// ./src/api/technology.js